export const getRemovedObligations = (newObligations, oldObligations) => {
    const result = [];
    if (oldObligations.length === 0) return [];
    oldObligations.forEach(obligation => {
        if (!newObligations.some(newObligation => newObligation.id === obligation.id)) {
            result.push(obligation);
        }
    });
    return result;
}